<template>
	<div class="container__grid">
		<div class="container__grid__main">
			<router-view />
		</div>
		<div class="container__grid__menu">
			<!-- <p style="
    color: white;
    background-color: var(--color-green);
    margin: 0;
    font-size: 10px;
    padding: 0.2rem;
    font-weight: bold;
    text-align: center;
">{{$t('weAreAlpha')}} v{{latestVersion}} <span @click="$router.push('/main/changelog')" style="text-decoration: underline; cursor: pointer;">{{$t('whatsNew')}}</span></p> -->
			<Menu />
		</div>
		<div class="container__grid__footer">
			<Footer />
		</div>

		<!-- Widget lateral do WalterIA (sistema-janela), global em todas as telas -->
		<WalterIASidePanel v-if="possuiWalterIAContratado" />
	</div>
</template>

<script>
import Footer from '../../components/Footer/Footer'
import Menu from '../../components/Menu/Menu'
import WalterIASidePanel from '../../components/WalterIA/WalterIASidePanel.vue'
import { mapGetters } from 'vuex'

export default {
	components: { Footer, Menu, WalterIASidePanel },
	computed: {
		...mapGetters('moduleChangelog', ['latestVersion']),
		possuiWalterIAContratado() {
			return JSON.parse(localStorage.getItem('user-modules')).includes('WALTER_AI')
		},
	},
}
</script>

<style scoped>
.container__grid {
	grid-template: 'grid_menu' 'grid_main' 'grid_footer';
	min-height: 100vh;
	display: grid;
	grid-template-rows: auto 1fr auto;
}

.container__grid__main {
	grid-area: grid_main;
	margin-top: 4rem;
	background-color: var(--color-background);
}

.container__grid__menu {
	grid-area: grid_menu;
	position: fixed;
	background-color: white;
	height: var(--menu-height);
	width: 100%;
	/* z-index alto para a navbar global (e seus submenus) ficar sempre acima
	   do conteúdo da página em todas as rotas */
	z-index: 100;
}

.container__grid__footer {
	grid-area: grid_footer;
	background-color: var(--color-background);
	height: 2.5rem;
	display: flex;
	justify-content: center;
	align-items: center;
}
</style>
